import { Icon } from "../Icon.jsx";
import { courseLevels } from "../../data/consultantCourse.js";

export function CoursePlans() {
  return (
    <section className="plans-section page-section" id="percorso" aria-labelledby="plans-title">
      <div className="section-index" aria-hidden="true"><span>02</span><i /></div>
      <div className="plans-section__heading">
        <div>
          <h2 id="plans-title">Tre livelli.<br />Un metodo che cresce con te.</h2>
        </div>
        <p>
          Pagamento unico, accesso online e risultati concreti. Puoi confrontare e acquistare
          subito: il test è facoltativo e serve soltanto a suggerire il livello di partenza.
        </p>
      </div>

      <div className="plan-grid" aria-label="Piani del percorso">
        {courseLevels.map((level) => (
          <article className="plan-card" key={level.name}>
            <div className="plan-card__topline">
              <span>{level.name}</span>
            </div>
            <strong className="plan-card__price">{level.price}</strong>
            <span className="plan-card__duration">{level.duration} · accesso online</span>
            <h3>{level.title}</h3>
            <p>{level.description}</p>
            <a className="button button--outline" href={level.href}>
              Scegli {level.name} <Icon name="arrow" size={18} />
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}
